import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  inject,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TimelineModalFilterService } from '../../services/timeline-modal-filter.service';

@Component({
  selector: 'wilson-filter-qualified-staff-changed-button',
  imports: [TranslateModule, NzButtonModule],
  templateUrl: './filter-qualified-staff-changed-button.component.html',
  styleUrls: ['./filter-qualified-staff-changed-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterQualifiedStaffChangedButtonComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  timelineModalFilterService = inject(TimelineModalFilterService);

  @Input() disabled!: boolean | null;

  async qualifiedStaffChanged() {
    this.timelineModalFilterService.qualifiedStaffChanged(false);
    this.cdRef.detectChanges();
  }
}
